import BaseItem, { Rarity } from './base_item';

export default class GunTerminal extends BaseItem {
    constructor(x, y) {
        super(x, y, "items", "gun_terminal.png");
    }

    static get phrases() {
        let p = {}
        p.pick = [
            "My preciouss..",
            "Let's kill somebody...",
            "Kill.. all.. asteroids..",
            "Mmmmm...",
            "Destroy... with lasers.."
        ];
        let a = new Array(8).fill("");
        p.pick = p.pick.concat(a);
        return p;
    }

    //this is width/height of collision box (attached to bottom)
    static get width() { return 15; }
    static get height() { return 8; }

    static get mass() { return 5; }
    static get electronic() { return true; }
    static get rarity() { return Rarity.RARE; }


    static get type() { return 'gun_terminal' }
    static get label() { return 'weapon control terminal' }
    static get description() {
        return `Weapon control terminal. The only command it recognizes is 'sudo kill'`
    }
}


// WEBPACK FOOTER //
// ./src/objects/items/gun_terminal.js